export default function ContactHero() {
  return (
    <section className="relative bg-gradient-to-b from-primary-900 via-primary-800 to-primary-900 pt-28 md:pt-36 pb-16 md:pb-20 px-6 md:px-12 lg:px-20">
      <div className="max-w-[1280px] mx-auto">
        <div className="inline-flex items-center gap-2 mb-8">
          <span className="text-accent-400 text-sm tracking-[0.2em] font-sans font-light">/</span>
          <span className="text-accent-400/80 text-xs md:text-sm tracking-[0.15em] font-sans font-light">お問合わせ</span>
        </div>

        <h2 className="text-2xl md:text-4xl lg:text-5xl font-heading font-light text-white tracking-[0.06em] leading-[1.35] max-w-2xl">
          専門家と
          <br />
          直接お話しください
        </h2>

        <div className="mt-6 md:mt-8 text-sm md:text-base text-foreground-200/80 tracking-[0.06em] leading-[1.9] font-sans font-light max-w-xl">
          <p>
            導入のご検討、技術的なご質問、資料請求など、どのようなご相談でも承ります。
            専門のスタッフが24時間以内にご返信いたします。
          </p>
        </div>
      </div>
    </section>
  );
}